import {
  AppBar, Container, Toolbar, Typography,
} from "@mui/material";
import { Logout, Person } from "@mui/icons-material";
import EquatureLogo from '../../assets/images/EquatureLogo.svg'


const Navbar = () => {
  return (
    <AppBar position="static" sx={{
      backgroundColor: '#2e3038 !important'
    }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <img src={EquatureLogo} width={100} height={50} />
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
